"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
exports.createMuiLinearProgressOverrides = function (_a) {
    var palette = _a.palette;
    return ({
        root: {
            height: 2,
        },
        colorSecondary: {
            backgroundColor: palette.type === "dark" ? palette.grey[800] : palette.grey[400],
        },
        barColorSecondary: {
            backgroundColor: palette.type === "dark" ? palette.grey[400] : palette.grey[800],
        },
        dashed: {
            animation: "none",
        },
        dashedColorSecondary: {
            backgroundImage: "radial-gradient(" + styles_1.fade(palette.grey[400], 0.5) + " 0%, " + styles_1.fade(palette.grey[400], 0.5) + " 16%, transparent 42%)",
        },
    });
};
//# sourceMappingURL=MuiLinearProgress.js.map